/**
 * Cart reservation countdown — 10 minutes from first cart drawer open.
 * Persists in sessionStorage until expiry.
 */
(function () {
  const STORAGE_KEY = 'wh_cart_reservation_ends_at';
  const DURATION_MS = 10 * 60 * 1000;

  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      this.labelEl = this.querySelector('[data-reservation-time]');
      this.tick = this.tick.bind(this);
      this.startOrResume();
      this._interval = setInterval(this.tick, 1000);
      this.tick();
    }

    disconnectedCallback() {
      if (this._interval) clearInterval(this._interval);
    }

    startOrResume() {
      const now = Date.now();
      let endsAt = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);

      if (!endsAt || endsAt <= now) {
        endsAt = now + DURATION_MS;
        sessionStorage.setItem(STORAGE_KEY, String(endsAt));
      }

      this.endsAt = endsAt;
    }

    tick() {
      if (!this.labelEl) return;

      const remaining = Math.max(0, this.endsAt - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      const formatted = `${minutes}:${String(seconds).padStart(2, '0')}`;

      this.labelEl.textContent = formatted;

      if (remaining <= 0) {
        // Restart a fresh window on expiry while the drawer is open
        this.startOrResume();
      }
    }
  }

  if (!customElements.get('cart-reservation-timer')) {
    customElements.define('cart-reservation-timer', CartReservationTimer);
  }

  // Ensure timer starts when drawer opens (in case element was already connected empty)
  document.addEventListener('cart-drawer:opened', () => {
    document.querySelectorAll('cart-reservation-timer').forEach((el) => {
      if (typeof el.startOrResume === 'function') {
        el.startOrResume();
        el.tick();
      }
    });
  });
})();
